const NEWS_ENDPOINT = '/api.php?action=get_daily_news';

class DailyNewsTicker extends HTMLElement {
  connectedCallback() {
    if (this.initialized) {
      return;
    }
    this.initialized = true;

    this.statusNode = this.querySelector('[data-news-status]');
    this.titleNode = this.querySelector('[data-news-title]');
    this.excerptNode = this.querySelector('[data-news-excerpt]');
    this.controlsNode = this.querySelector('[data-news-controls]');
    this.counterNode = this.querySelector('[data-news-counter]');
    this.previousButton = this.querySelector('[data-news-previous]');
    this.nextButton = this.querySelector('[data-news-next]');
    this.items = [];
    this.currentIndex = 0;

    this.previousButton.addEventListener('click', () => this.showItem(this.currentIndex - 1));
    this.nextButton.addEventListener('click', () => this.showItem(this.currentIndex + 1));
    this.addEventListener('mouseenter', () => this.stopRotation());
    this.addEventListener('mouseleave', () => this.startRotation());
    this.addEventListener('focusin', () => this.stopRotation());
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) {
        this.startRotation();
      }
    });

    this.loadNews();
  }

  disconnectedCallback() {
    this.stopRotation();
  }

  async loadNews() {
    try {
      const response = await fetch(NEWS_ENDPOINT, { cache: 'no-store' });
      const data = await response.json();
      if (!response.ok || !data.success || !Array.isArray(data.news)) {
        throw new Error(data.message || 'Die Lach-News konnten nicht geladen werden.');
      }

      this.items = data.news.filter((item) => (
        item
                && typeof item.title === 'string'
                && typeof item.url === 'string'
                && typeof item.excerpt === 'string'
                && this.isNewsUrl(item.url)
      ));

      this.setAttribute('aria-busy', 'false');
      if (this.items.length === 0) {
        this.setStatus('Heute gibt es keine neuen Lach-News.');
        return;
      }

      this.statusNode.hidden = true;
      this.titleNode.hidden = false;
      this.excerptNode.hidden = false;
      this.controlsNode.hidden = this.items.length < 2;
      this.showItem(0);
      this.startRotation();
    } catch (error) {
      console.error('Daily news could not be loaded:', error);
      this.setAttribute('aria-busy', 'false');
      this.setStatus('Die Lach-News sind momentan nicht verfügbar.');
    }
  }

  isNewsUrl(value) {
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin
                && url.pathname.startsWith('/news/')
                && !url.search
                && !url.hash;
    } catch {
      return false;
    }
  }

  showItem(index) {
    if (this.items.length === 0) {
      return;
    }

    this.currentIndex = (index + this.items.length) % this.items.length;
    const item = this.items[this.currentIndex];
    this.titleNode.href = item.url;
    this.titleNode.textContent = item.title;
    this.excerptNode.textContent = item.excerpt;
    this.counterNode.textContent = `${this.currentIndex + 1}/${this.items.length}`;
    this.previousButton.disabled = this.items.length < 2;
    this.nextButton.disabled = this.items.length < 2;
  }

  setStatus(message) {
    this.statusNode.textContent = message;
    this.statusNode.hidden = false;
    this.titleNode.hidden = true;
    this.excerptNode.hidden = true;
    this.controlsNode.hidden = true;
  }

  startRotation() {
    this.stopRotation();
    if (this.items.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.rotationTimer = window.setInterval(() => {
        this.showItem(this.currentIndex + 1);
      }, 7000);
    }
  }

  stopRotation() {
    if (this.rotationTimer) {
      window.clearInterval(this.rotationTimer);
      this.rotationTimer = null;
    }
  }
}

if (!customElements.get('daily-news-ticker')) {
  customElements.define('daily-news-ticker', DailyNewsTicker);
}
